import { createContext, Component } from 'react'

export type SubtreeTrackerCallback = () => void
export type SubtreeTrackerContextType = {
  addSubtreeTrackingListener: (callback: SubtreeTrackerCallback) => void
  removeSubtreeTrackingListener: (callback: SubtreeTrackerCallback) => void
}

export const SubtreeTrackerContext = createContext<SubtreeTrackerContextType>({
  addSubtreeTrackingListener: () => null,
  removeSubtreeTrackingListener: () => null,
})

/*
  !!!!!!!!!!!!!! DEPRECATED !!!!!!!!!!!!
  use socialFeed/SubtreeMutation/SubtreeMutation.tsx
*/
class SubtreeTracker extends Component {
  private callbacks: SubtreeTrackerCallback[] = []
  private observer: MutationObserver | null = null

  private rootNode: HTMLDivElement | null = null

  render () {
    const { children } = this.props

    return (
      <div className='subtreeTracker' ref={ (node) => { this.rootNode = node } }>
        <SubtreeTrackerContext.Provider value={ this.getContextValue() }>
          { children }
        </SubtreeTrackerContext.Provider>
      </div>
    )
  }

  componentDidMount () {
    this.ensureObserverConnected()
  }

  componentDidUpdate () {
    this.ensureObserverConnected()
  }

  componentWillUnmount () {
    this.disconnectObserver()
    this.callbacks = []
  }

  private getContextValue (): SubtreeTrackerContextType {
    return {
      addSubtreeTrackingListener: this.addSubtreeTrackingListener,
      removeSubtreeTrackingListener: this.removeSubtreeTrackingListener,
    }
  }

  private connectObserver = () => {
    if (!this.rootNode) {
      return
    }

    if (!this.observer) {
      this.observer = new MutationObserver(this.callSubscribers)
    }
    this.observer.observe(this.rootNode, { subtree: true, childList: true })
  }

  private disconnectObserver = () => {
    if (this.observer) {
      this.observer.disconnect()
      this.observer = null
    }
  }

  private callSubscribers = () => {
    this.callbacks.forEach((callback) => callback.call(null))
  }

  private addSubtreeTrackingListener = (callback: SubtreeTrackerCallback) => {
    if (!(window as any).MutationObserver) {
      return
    }

    this.callbacks.push(callback)
    this.ensureObserverConnected()
  }

  private removeSubtreeTrackingListener = (callback: SubtreeTrackerCallback) => {
    if (!(window as any).MutationObserver) {
      return
    }

    this.callbacks = this.callbacks.filter((c) => c !== callback)
    if (!this.callbacks.length) {
      this.disconnectObserver()
    }
  }

  private ensureObserverConnected () {
    if (this.callbacks.length > 0) {
      this.connectObserver()
    }
  }
}

export default SubtreeTracker
